"use strict";
//
// ---- Field Value Operand
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERAND_TYPE_LIST = exports.OPERAND_TYPE_FUNCTION = exports.OPERAND_TYPE_KEYWORD = exports.KEYWORD_OPERAND_EMPTY = exports.OPERAND_TYPE_FIELD_VALUE = exports.NODE_TYPE_FIELD_OPERAND = void 0;
exports.NODE_TYPE_FIELD_OPERAND = 'field_operand';
exports.OPERAND_TYPE_FIELD_VALUE = 'field_value';
//
// ---- Keyword Operand
//
exports.KEYWORD_OPERAND_EMPTY = 'empty';
exports.OPERAND_TYPE_KEYWORD = 'keyword';
exports.OPERAND_TYPE_FUNCTION = 'function';
exports.OPERAND_TYPE_LIST = 'list';
//# sourceMappingURL=operand.js.map